<template>
    <div class="footer">
        <div class="waper">
            <label>{{ i18n.$t('Footer1')}}</label><br>
            <label>{{ i18n.$t('Footer2')}}</label>
        </div>
    </div>
</template>
<script>
import { useI18n } from "@/i18nPlugin";
export default {
    setup() {
      const i18n = useI18n();
      return { i18n };
    },
};
</script>
<style scoped>
    .footer {
        background: rgb(245, 245, 245);
        border-top: 1px solid #e2e4e6;
        font-size: 12px;
        color: #353535;
        padding: 17px 0;
        min-width: 620px;
        width: 100%;
        position: absolute;
    }
    .footer .waper {
        text-align: center;
        width: auto;
    }
    .WebInformation {
        margin: 10px 10%;
    }
    .WebAddress {
        margin: 10px 20px;
        text-align: -webkit-center;
    }
    .WebAddress td{
        width:25%;
        text-align: center;
        padding: 10px 50px;
    }
</style>
